const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/subscriptions/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/subscriptions/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Tab = "overview" | "pending" | "ledger";